import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { FaChevronCircleRight } from 'react-icons/fa';
import { CourseTags } from '../../components/index';
import './style.sass';
import { useNavigate } from 'react-router-dom';
import WithNavBar from '../../Layouts/WithNavBar';
import CustomFooter from '../../components/CustomFooter';
import * as TYPES from '../../store/actions/actions.js';

function Courses() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [coursesData, setCoursesData] = useState([]);

  // 检查当前域名是否包含 beecadvantage.cn
  const isLocalhost = window.location.hostname.includes('beecadvantage.cn');

  useEffect(() => {
    dispatch({
      type: TYPES.LOADER_TEXT,
      data: '',
    });
    dispatch(Actions.listAllCourses());
  }, []);

  const [listAllCourses] = useSelector((state) => {
    return [state.courses.listCourses];
  });

  // Group courses by type
  useEffect(() => {
    // 如果域名包含 localhost，使用 cndisplay，否则使用 display
    const displayField = isLocalhost ? 'cndisplay' : 'display';
    // 只有为 'show' 的课程才显示，其他都隐藏
    const filteredCourses = listAllCourses.filter(
      (course) =>
        course[displayField] === 'show' && (course?.type === 'SAT' || course?.type === 'HSPT'),
    );
    setCoursesData(filteredCourses);
  }, [listAllCourses, isLocalhost]);

  // Group courses by type for rendering
  const groupedCourses = coursesData.reduce((acc, course) => {
    const type = course.type || 'Uncategorized'; // Fallback to 'Uncategorized' if type is undefined
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(course);
    return acc;
  }, {});

  const sortedGroupedCourses = Object.fromEntries(
    Object.entries(groupedCourses).map(([type, arr]) => {
      const sorted = [...arr].sort((a, b) => {
        const nameA = (a?.alias || a?.title || '').toString().toLowerCase();
        const nameB = (b?.alias || b?.title || '').toString().toLowerCase();
        return nameA.localeCompare(nameB);
      });
      return [type, sorted];
    }),
  );

  return (
    <WithNavBar IsLoggedIn={true}>
      <div className="third-section" id="myCoursesSection">
        <div className="container pb-5">
          <div className="col-md-6 mx-auto text-center mt-5">
            <h1 className="mb-0 heading-1">All Courses</h1>
            <p className="summary mt-3">
              Comprehensive assessments designed to simulate realistic testing conditions and
              provide truly actionable insights. Stop worrying about your next exam and join
              thousands of other students that have already experienced the BEEC Advantage. Get
              started today!
            </p>
          </div>
          <div className="row mx-0">
            <div className="course-inner my-4">
              {Object.keys(sortedGroupedCourses).map((type, index) => (
                <div key={index} className="mb-5">
                  <h2 className="heading-2 mb-4">{type} Courses</h2>
                  <Row xs={1} md={2} lg={3} xl={3}>
                    {sortedGroupedCourses[type].map((data, key) => (
                      <>
                        {data?.status === 'ENABLED' && (
                          <Col className="my-3" key={key}>
                            <Card
                              className="h-100 shadow"
                              onClick={() => {
                                dispatch(Actions.selectedCourseForRegistration(data));
                                navigate('/course-registration');
                              }}
                            >
                              <CourseTags tag={data?.category} />
                              <Card.Img
                                variant="top"
                                className="img-fluid courses-top-img"
                                src={data?.image}
                              />
                              <Card.Body>
                                <h4 className="heading-4 name mb-1 mt-2 text-center">
                                  {data?.alias ? data?.alias : data?.title}
                                </h4>
                                <p className="summary body-1 mb-0 mt-4">{data?.summary}</p>
                              </Card.Body>
                              <Card.Footer className="pb-3">
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div className=""></div>
                                    <div className="ms-2"></div>
                                  </div>
                                  <div className="course-link">
                                    Buy
                                    <FaChevronCircleRight size={'1.5em'} />
                                  </div>
                                </div>
                              </Card.Footer>
                            </Card>
                          </Col>
                        )}
                      </>
                    ))}
                  </Row>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <CustomFooter />
    </WithNavBar>
  );
}

export default Courses;
